export default "__VITE_ASSET__A5T2hc2G__"